var _polygon, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHidrante(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.5,
    height: 29.5,
    viewBox: "0 0 29.5 29.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "14.75,0 0,29.5 29.5,29.5",
    fill: "red",
    stroke: "#0008"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.8,
    y: 14.2,
    width: 11.5,
    height: 13,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidrante);
export default __webpack_public_path__ + "static/media/hidrante.2d545c8b415aadd6bf70e8a4e396464c.svg";
export { ForwardRef as ReactComponent };